/**
 * You can register global mixins here
 */

const GlobalMixins = {
    install(Vue) {
        Vue.mixin({
            mounted() {
                let {
                    bodyClass
                } = this.$options;
                if (bodyClass) {
                    bodyClass.split(',').map( x => {
                    document.body.classList.add(x);
                    })
                }
            },
            beforeDestroy() {
                let {
                    bodyClass
                } = this.$options;
                if (bodyClass) {
                    bodyClass.split(',').map( x => {
                    document.body.classList.remove(x);
                    })
                }
            }
        })
    }
}
export default GlobalMixins
